import { ApiPath } from "enums";
import { Delete, Get, Patch } from "utils";

const resolveCampaignCode = (campaignCode) => {
  return (
    campaignCode ||
    localStorage.getItem("campaignCode") ||
    localStorage.getItem("organizationId") ||
    ""
  );
};

const appendCsvParam = (params, key, values) => {
  const cleanValues = (Array.isArray(values) ? values : [])
    .map((value) => String(value ?? "").trim())
    .filter(Boolean);

  if (cleanValues.length > 0) {
    params.set(key, cleanValues.join(","));
  }
};

const appendFieldResponseProcessedFilters = (
  params,
  {
    sentiment = [],
    enumerator = [],
    sex = [],
    ageBand = [],
    cohortIds = [],
    recordingId = "",
  } = {},
) => {
  appendCsvParam(params, "sentiment", sentiment);
  appendCsvParam(params, "sex", sex);
  appendCsvParam(params, "ageBand", ageBand);
  appendCsvParam(params, "cohortIds", cohortIds);

  (Array.isArray(enumerator) ? enumerator : [])
    .map((value) => String(value ?? "").trim())
    .filter(Boolean)
    .forEach((value) => params.append("enumerator", value));

  const normalizedRecordingId = String(recordingId || "").trim();
  if (normalizedRecordingId) {
    params.set("recordingId", normalizedRecordingId);
  }
};

export const getFieldResponseProcessedFilterOptions = async ({ campaignCode } = {}) => {
  const res = await Get(ApiPath.SurveyFieldResponsesProcessedFilterOptions, {
    campaignCode: resolveCampaignCode(campaignCode),
  });
  return res.data;
};

export const getFieldResponsesProcessed = async ({
  campaignCode,
  page = 1,
  perPage = 100,
  sentiment = [],
  enumerator = [],
  sex = [],
  ageBand = [],
  cohortIds = [],
  recordingId = "",
} = {}) => {
  const params = new URLSearchParams();

  params.set("campaignCode", resolveCampaignCode(campaignCode));
  params.set("page", page);
  params.set("perPage", perPage);
  appendFieldResponseProcessedFilters(params, {
    sentiment,
    enumerator,
    sex,
    ageBand,
    cohortIds,
    recordingId,
  });

  const res = await Get(ApiPath.SurveyFieldResponsesProcessed, params);
  return res.data;
};

export const getFieldResponseProcessedMapPoints = async ({ campaignCode, ...filters } = {}) => {
  const params = new URLSearchParams();

  params.set("campaignCode", resolveCampaignCode(campaignCode));
  appendFieldResponseProcessedFilters(params, filters);

  const res = await Get(ApiPath.SurveyFieldResponsesProcessedMapPoints, params);
  return res.data;
};

export const deleteFieldResponseProcessed = async ({ fieldResponseProcessedId }) => {
  const res = await Delete(
    `${ApiPath.SurveyFieldResponsesProcessed}/${encodeURIComponent(fieldResponseProcessedId)}`,
  );
  return res.data;
};

export const getFieldResponseProcessedTranscript = async ({ fieldResponseProcessedId }) => {
  const res = await Get(
    `${ApiPath.SurveyFieldResponsesProcessed}/${encodeURIComponent(fieldResponseProcessedId)}/transcript`,
  );
  return res.data;
};

export const updateFieldResponseProcessedTranscriptRow = async ({
  fieldResponseProcessedId,
  segmentIndex,
  text,
}) => {
  const res = await Patch(
    `${ApiPath.SurveyFieldResponsesProcessed}/${encodeURIComponent(
      fieldResponseProcessedId,
    )}/transcript/rows/${encodeURIComponent(segmentIndex)}`,
    {
      text,
    },
  );
  return res.data;
};

export const restoreFieldResponseProcessedTranscriptRow = async ({
  fieldResponseProcessedId,
  segmentIndex,
}) => {
  const res = await Delete(
    `${ApiPath.SurveyFieldResponsesProcessed}/${encodeURIComponent(
      fieldResponseProcessedId,
    )}/transcript/rows/${encodeURIComponent(segmentIndex)}`,
  );
  return res.data;
};

export const restoreFieldResponseProcessedTranscript = async ({ fieldResponseProcessedId }) => {
  const res = await Delete(
    `${ApiPath.SurveyFieldResponsesProcessed}/${encodeURIComponent(fieldResponseProcessedId)}/transcript`,
  );
  return res.data;
};

export const updateFieldResponseProcessedIdentity = async (params = {}) => {
  const { fieldResponseProcessedId, sex, ageBand } = params;
  const body = {};

  if (Object.prototype.hasOwnProperty.call(params, "sex")) {
    body.sex = sex;
  }
  if (Object.prototype.hasOwnProperty.call(params, "ageBand")) {
    body.ageBand = ageBand;
  }

  const res = await Patch(
    `${ApiPath.SurveyFieldResponsesProcessed}/${encodeURIComponent(fieldResponseProcessedId)}/identity`,
    body,
  );
  return res.data;
};
